export default {
    unauthorized: {
        text: 'Unauthorized error. Please, sign in again.',
        title: 'Uups...',
    },
    unknown: {
        text: 'Unexpected error. Please, try again or contact us.',
        title: 'Uups...',
    },
    notfound: {
        text: 'Not found resource.',
        title: 'Uups...',
    },
    conflict: {
        text: 'Invalid resource.',
        title: 'Uups...',
    },
    auth: {
        text: 'Wrong email or password.',
        title: 'Invalid credentials',
    },
    404: {
        title: 'Page not found',
    },
    select: {
        noOptions: 'No elements found.',
    },
    codeLinterSuggestions: {
        unknownVariable: 'Unknown variable ("{code}").',
        unknownVariableOrRelation: 'Unknown variable or related entity "{variable}" ("{code}").',
        entityWithNoRelation: 'You cannot use an entity as a variable ("{code}").',
        sameEntity: 'You cannot use the entity itself as a related one ("{code}").',
        mispelledRelatedName: 'Unknown variable ("{code}"). Just in case... did you mean "{relation}" instead of "{entity}"?',
        notRelatedEntity: 'Entity "{entityKey}" is not related with this one ("{code}").',
        entityWithUnknownColumn: 'Entity "{entityKey}" do not have a the column "{columnKey}" ("{code}").',
    },
}
